/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Client } from '../../models/client';

export interface MonitorGetAllClientsPost$Params {
}

export function monitorGetAllClientsPost(http: HttpClient, rootUrl: string, params?: MonitorGetAllClientsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Client>>> {
  const rb = new RequestBuilder(rootUrl, monitorGetAllClientsPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Client>>;
    })
  );
}

monitorGetAllClientsPost.PATH = '/Monitor/GetAllClients';
